'use client';

/**
 * SLIMS PRO — contenuti specifici del chrome. Header, sidebar e frame della shell
 * sono condivisi con SLIMS CER (`AppHeader`, `SidebarNavigation`, `AppShellFrame`):
 * qui restano solo i controlli che PRO inserisce nei loro slot.
 */

export type ProModeId = 'fleet' | 'single' | 'field';

export interface ProMode {
	id: ProModeId;
	label: string;
}

export const PRO_MODES: ProMode[] = [
	{ id: 'fleet', label: 'Fleet / Multi-Sito' },
	{ id: 'single', label: 'Impianto Singolo' },
	{ id: 'field', label: 'Campo Utility-Scale' },
];

export interface ProPlantOption {
	id: string;
	label: string;
}

export interface ProPlantSelectProps {
	/** Impianti/campi selezionabili per la modalità corrente; vuoto → selettore nascosto. */
	plants: ProPlantOption[];
	selectedPlantId: string | null;
	onSelectPlant: (id: string) => void;
}

/** Selettore impianto dell'header PRO, dimensionato sui controlli dell'header. */
export function ProPlantSelect({ plants, selectedPlantId, onSelectPlant }: ProPlantSelectProps) {
	if (plants.length === 0) return null;
	return (
		<select
			aria-label="Impianto"
			value={selectedPlantId ?? ''}
			onChange={(e) => onSelectPlant(e.target.value)}
			className="h-[38px] max-w-52 flex-none truncate rounded-btn border border-border bg-card px-2.5 text-[13px] text-brand outline-none focus:border-brand"
		>
			{plants.map((p) => (
				<option key={p.id} value={p.id}>
					{p.label}
				</option>
			))}
		</select>
	);
}
